export default {
  resetZoom: 'Resetuj powiększenie',
  tool: {
    zoomXy: 'Powiększenie',
    zoomX: 'Powiększenie X',
    zoomY: 'Powiększenie Y',
    pan: 'Przesuwanie',
  },
};
